import { Dayjs } from 'dayjs';
import { AddressType } from 'types';

interface ActionTypes {
  SET_ENQUIRY_ADDRESS: string;
  SET_SHAPE: string;
  SET_MULTIPLE_SHAPES: string;
  SET_WORKING_ON_BEHALF_OF_LIST: string;
  SET_ENQUIRY_ACT_DESIGN: string;
  SET_ENQUIRY_ACT_EXCAVATE: string;
  SET_EARLIEST_VALID_DATE: string;
  SET_LIVE_AREA: string;
  SET_MULTIPLE_DRAW_MODE: string;
  REMOVE_SHAPE: string;
  CLEAR_SHAPE: string;
  CLEAR_DUPLICATE_ENQUIRY: string;
  CLEAR_LODGED_ENQUIRY: string;
  GET_GEOCODE_START: string;
  GET_GEOCODE_SUCCESS: string;
  GET_GEOCODE_FAILURE: string;
  GET_ENQUIRY_ESSENTIALS_START: string;
  GET_ENQUIRY_ESSENTIALS_SUCCESS: string;
  GET_ENQUIRY_ESSENTIALS_FAILURE: string;
  GET_ASSET_OWNERS_COUNT_START: string;
  GET_ASSET_OWNERS_COUNT_SUCCESS: string;
  GET_ASSET_OWNERS_COUNT_FAILURE: string;
  QUERY_RECENT_LAYER_EXTENT_START: string;
  QUERY_RECENT_LAYER_EXTENT_SUCCESS: string;
  UPLOAD_ENQUIRY_SHAPE_START: string;
  UPLOAD_ENQUIRY_SHAPE_SUCCESS: string;
  UPLOAD_ENQUIRY_SHAPE_FAILURE: string;
  GET_DUPLICATE_ENQUIRY_START: string;
  GET_DUPLICATE_ENQUIRY_SUCCESS: string;
  GET_DUPLICATE_ENQUIRY_FAILURE: string;
  GET_LAST_ENQUIRY_START: string;
  GET_LAST_ENQUIRY_SUCCESS: string;
  GET_LAST_ENQUIRY_FAILURE: string;
  LODGE_NEW_ENQUIRY_START: string;
  LODGE_NEW_ENQUIRY_SUCCESS: string;
  LODGE_NEW_ENQUIRY_FAILURE: string;
  SET_PENDING_ENQUIRIES_AMOUNT: string;
  SET_BULK_CREATING: string;
  SET_BULK_BATCH_TOTAL: string;
  SET_BULK_BATCH_CREATED: string;
  SET_SUCCESS_ENQUIRY_USER_REFERENCE: string;
  SET_MAP_ERROR_FOR_LODGE_ENQUIRY_FAIL: string;
  UPDATE_NEW_LODGED_ENQUIRIES: string;
  SET_FAILED_ENQUIRIES: string;
  CLEAR_FAILED_ENQUIRIES: string;
  CHECK_SHAPE_WITHIN_TEAM_START: string;
  CHECK_SHAPE_WITHIN_TEAM_SUCCESS: string;
  CHECK_SHAPE_WITHIN_TEAM_FAILURE: string;
  USE_UPLOADED_SHAPE_USER_REFERENCE: string;
  SAVE_DRAFT_START: string;
  SAVE_DRAFT_SUCCESS: string;
  SAVE_DRAFT_FAILURE: string;
  GET_RESTRICTIONS_START: string;
  GET_RESTRICTIONS_SUCCESS: string;
  GET_RESTRICTIONS_FAILURE: string;
  GET_DRAFT_START: string;
  GET_DRAFT_SUCCESS: string;
  GET_DRAFT_FAILURE: string;
  DISCARD_DRAFT_START: string;
  DISCARD_DRAFT_SUCCESS: string;
  DISCARD_DRAFT_FAILURE: string;
}

export interface SetShapePayload {
  shapeId: string;
  uid: number;
  geoJson: GeoJSON.GeometryObject | null | undefined;
  area: number | null | undefined;
  centroid: {
    latitude: number;
    longitude: number;
  };
  isError?: boolean;
  userReference?: string;
  address?: AddressType;
}

export const LodgeEnquiryActionTypes: ActionTypes = {
  SET_ENQUIRY_ADDRESS: '@@SET_ENQUIRY_ADDRESS',
  SET_SHAPE: '@@SET_SHAPE',
  SET_MULTIPLE_SHAPES: '@@SET_MULTIPLE_SHAPES',
  SET_WORKING_ON_BEHALF_OF_LIST: '@@SET_WORKING_ON_BEHALF_OF_LIST',
  SET_ENQUIRY_ACT_DESIGN: '@@SET_ENQUIRY_ACT_DESIGN',
  SET_ENQUIRY_ACT_EXCAVATE: '@@SET_ENQUIRY_ACT_EXCAVATE',
  SET_EARLIEST_VALID_DATE: '@@SET_EARLIEST_VALID_DATE',
  SET_LIVE_AREA: '@@SET_LIVE_AREA',
  SET_MULTIPLE_DRAW_MODE: '@@SET_MULTIPLE_DRAW_MODE',
  REMOVE_SHAPE: '@@REMOVE_SHAPE',
  CLEAR_SHAPE: '@@CLEAR_SHAPE',
  CLEAR_DUPLICATE_ENQUIRY: '@@CLEAR_DUPLICATE_ENQUIRY',
  CLEAR_LODGED_ENQUIRY: '@@CLEAR_LODGED_ENQUIRY',
  GET_GEOCODE_START: '@@GET_GEOCODE_START',
  GET_GEOCODE_SUCCESS: '@@GET_GEOCODE_SUCCESS',
  GET_GEOCODE_FAILURE: '@@GET_GEOCODE_FAILURE',
  GET_ENQUIRY_ESSENTIALS_START: '@@GET_ENQUIRY_ESSENTIALS_START',
  GET_ENQUIRY_ESSENTIALS_SUCCESS: '@@GET_ENQUIRY_ESSENTIALS_SUCCESS',
  GET_ENQUIRY_ESSENTIALS_FAILURE: '@@GET_ENQUIRY_ESSENTIALS_FAILURE',
  GET_ASSET_OWNERS_COUNT_START: '@@GET_ASSET_OWNERS_COUNT_START',
  GET_ASSET_OWNERS_COUNT_SUCCESS: '@@GET_ASSET_OWNERS_COUNT_SUCCESS',
  GET_ASSET_OWNERS_COUNT_FAILURE: '@@GET_ASSET_OWNERS_COUNT_FAILURE',
  QUERY_RECENT_LAYER_EXTENT_START: '@@QUERY_RECENT_LAYER_EXTENT_START',
  QUERY_RECENT_LAYER_EXTENT_SUCCESS: '@@QUERY_RECENT_LAYER_EXTENT_SUCCESS',
  UPLOAD_ENQUIRY_SHAPE_START: '@@UPLOAD_ENQUIRY_SHAPE_START',
  UPLOAD_ENQUIRY_SHAPE_SUCCESS: '@@UPLOAD_ENQUIRY_SHAPE_SUCCESS',
  UPLOAD_ENQUIRY_SHAPE_FAILURE: '@@UPLOAD_ENQUIRY_SHAPE_FAILURE',
  GET_DUPLICATE_ENQUIRY_START: '@@GET_DUPLICATE_ENQUIRY_START',
  GET_DUPLICATE_ENQUIRY_SUCCESS: '@@GET_DUPLICATE_ENQUIRY_SUCCESS',
  GET_DUPLICATE_ENQUIRY_FAILURE: '@@GET_DUPLICATE_ENQUIRY_FAILURE',
  GET_LAST_ENQUIRY_START: '@@GET_LAST_ENQUIRY_START',
  GET_LAST_ENQUIRY_SUCCESS: '@@GET_LAST_ENQUIRY_SUCCESS',
  GET_LAST_ENQUIRY_FAILURE: '@@GET_LAST_ENQUIRY_FAILURE',
  LODGE_NEW_ENQUIRY_START: '@@LODGE_NEW_ENQUIRY_START',
  LODGE_NEW_ENQUIRY_SUCCESS: '@@LODGE_NEW_ENQUIRY_SUCCESS',
  LODGE_NEW_ENQUIRY_FAILURE: '@@LODGE_NEW_ENQUIRY_FAILURE',
  SET_PENDING_ENQUIRIES_AMOUNT: '@@SET_PENDING_ENQUIRIES_AMOUNT',
  SET_BULK_CREATING: '@@SET_BULK_CREATING',
  SET_BULK_BATCH_TOTAL: '@@SET_BULK_BATCH_TOTAL',
  SET_BULK_BATCH_CREATED: '@@SET_BULK_BATCH_CREATED',
  UPDATE_NEW_LODGED_ENQUIRIES: '@@UPDATE_NEW_LODGED_ENQUIRIES',
  SET_SUCCESS_ENQUIRY_USER_REFERENCE: '@@SET_SUCCESS_ENQUIRY_USER_REFERENCE',
  SET_MAP_ERROR_FOR_LODGE_ENQUIRY_FAIL:
    '@@SET_MAP_ERROR_FOR_LODGE_ENQUIRY_FAIL',
  SET_FAILED_ENQUIRIES: '@@SET_FAILED_ENQUIRIES',
  CLEAR_FAILED_ENQUIRIES: '@@CLEAR_FAILED_ENQUIRIES',
  CHECK_SHAPE_WITHIN_TEAM_START: '@@CHECK_SHAPE_WITHIN_TEAM_START',
  CHECK_SHAPE_WITHIN_TEAM_SUCCESS: '@@CHECK_SHAPE_WITHIN_TEAM_SUCCESS',
  CHECK_SHAPE_WITHIN_TEAM_FAILURE: '@@CHECK_SHAPE_WITHIN_TEAM_FAILURE',
  USE_UPLOADED_SHAPE_USER_REFERENCE: '@@USE_UPLOADED_SHAPE_USER_REFERENCE',
  SAVE_DRAFT_START: '@@SAVE_DRAFT_START',
  SAVE_DRAFT_SUCCESS: '@@SAVE_DRAFT_SUCCESS',
  SAVE_DRAFT_FAILURE: '@@SAVE_DRAFT_FAILURE',
  GET_DRAFT_START: '@@GET_DRAFT_START',
  GET_DRAFT_SUCCESS: '@@GET_DRAFT_SUCCESS',
  GET_DRAFT_FAILURE: '@@GET_DRAFT_FAILURE',
  GET_RESTRICTIONS_START: '@@GET_RESTRICTIONS_START',
  GET_RESTRICTIONS_SUCCESS: '@@GET_RESTRICTIONS_SUCCESS',
  GET_RESTRICTIONS_FAILURE: '@@GET_RESTRICTIONS_SUCCESS',
  DISCARD_DRAFT_START: '@@DISCARD_DRAFT_START',
  DISCARD_DRAFT_SUCCESS: '@@DISCARD_DRAFT_SUCCESS',
  DISCARD_DRAFT_FAILURE: '@@DISCARD_DRAFT_FAILURE'
};

export interface EnquiryShape {
  shapeId: string;
  uid: number;
  geoJson: GeoJSON.GeometryObject;
  address: AddressType;
  area: number;
  centroid: {
    latitude: number;
    longitude: number;
  };
  isError?: boolean;
  isFailedLodge?: boolean;
  userReference?: string;
  lastSeqNo?: number;
}

export interface draftShape {
  id: string;
  shape: GeoJSON.GeometryObject;
  address: AddressType;
  user_reference?: string;
  project_id?: number;
  seq_no?: number;
}
export interface restriction {
  allow: boolean;
  total: number;
  used: number;
}

export interface LodgeEnquiryState {
  shapes: EnquiryShape[];
  multipleDrawMode: boolean;
  shapeArea?: number;
  liveArea?: number;
  geocodeResponse?: any;
  geocodeLoading?: boolean;
  lodgingNewEnquiry?: boolean;
  lodgeEnquiryError?: string;
  pendingEnquiriesAmount?: number;
  bulkCreating?: boolean;
  bulkBatchTotal?: number;
  bulkBatchCreated?: number;
  failedEnquiries: any[];
  enquiries: any[];
  lastEnquiry?: any;
  duplicating?: boolean;
  duplicateEnquiry?: any;
  recentLayerExtent?: any;
  assetOwnerNumLoading?: boolean;
  assetOwnerNum?: number;
  essentialsLoading?: boolean;
  authorityTypeList?: any[];
  authorityList?: any[];
  designAct?: any;
  excavationAct?: any;
  earliestValidDate?: string;
  uploading?: boolean;
  uploadError?: string;
  uploadedShapes: GeoJSON.GeometryObject[];
  uploadedShapesUserReferences: any[];
  shapeWithinTeam?: 'checking' | 'outside' | 'within';
  useUploadedShapeUserReference?: false;
  draft?: {
    shapes: draftShape[];
    details: {
      data: LodgeEnqyiryInitialValues;
    };
  };
  fetchingDraft?: boolean;
  savingDraft?: boolean;
  discardingDraft?: boolean;
  discardedDraft?: boolean;
  draftTouched?: boolean;
  restriction?: restriction;
}

export type LodgeEnqyiryInitialValues = {
  locations: string[];
  addressLine1?: string;
  addressLocality?: string;
  addressPostcode?: string;
  addressState?: string;
  enquiryType?: string;
  activityId?: string | string[];
  jobStartDate: string | Dayjs;
  jobEndDate: string | Dayjs;
  userReference: string;
  notes: string;
  authorityType?: string;
  authorityId?: string;
  autoRenew: boolean;
  autoRenewEvery?: string;
  autoRenewUntil?: string;
  duplicateFrom?: number;
  retryFailed?: boolean;
  otherAuthorityName?: string;
};
